<template>
<modal
  name="item-modifiers"
  width="90%"
  height="auto"
  :adaptive="true"
  draggable=".window-header"
  :style="mainSectionTopRadius "
  :class="[
    'rounded-t-xxl vm-modal2 vm-modal3 h-40 overflow-y',
  ]"
  scrollable
  @before-close="$emit('before-close')"
  @before-open="openingModal"
>     
      <a
        @click="$modal.hide('item-modifiers')"
        class="h-10 w-10 rounded-full flex justify-center items-center absolute right-4 top-4 z-50"
      >
        <IconCancel
          :style="btnDestructiveBackground"
          :stroke="btnDestructiveIcon"
          :fill="btnDestructiveIcon"
        />
      </a>
      <!-- img -->
      <div v-if="menu.product_images_enabled && selectedMenuCategory.enable_product_images" class="relative">
        <!-- <img
          v-if="currentItem.pictureUrl"
          :src="currentItem.pictureUrl"
          alt
          class="object-cover rounded-t-xxl w-full h-56"
        /> -->
        <Picture
          v-if="currentItem.pictureUrl"
          :src="currentItem.pictureUrl"
          alt
          class="object-cover rounded-t-xxl w-full h-64"
          :style="mainSectionTopRadius "
        />
      </div>
      <div
        :class="[
          'flex flex-col rounded-xxl h-full',
          // currentItem.pictureUrl && menu.product_images_enabled
          //   ? '-mt-10 '
          //   : '',
        ]"
      >
        <div
          class="z-20 rounded-xxl h-full flex flex-col justify-between bg-cover"
          :style="modifierContentBorderRadius + (menuSubCategoriesBackground ? menuSubCategoriesBackground : backgroundMainFullImage ? backgroundMainFullImage : mainSubCategorysBackground)"
        >
          <!-- Top Action Button -->
          <div class="py-5 -mb-5 px-10 sticky top-0 rouned-t-xxl">
            <button
              v-if="currentItem.isComboDeal&&comboItemSelectionStep !== 0 || !currentItem.isComboDeal && modifiersSelectionGroups > 1 && modifierSelectionStep != 0"
              @click="previousStep"
              class="h-10 w-10 rounded-full flex justify-center items-center absolute left-4 top-4"
              :class="[
                !canGoBack
                  ? 'opacity-40 cursor-not-allowed'
                  : 'opacity-100',
              ]"
              :disabled="currentItem.isComboDeal ? (comboItemSelectionStep == 0 || !canGoBack) : false"
            >

              <IconBackArrow
                class="fill-current inline-block h-8 w-8 p-2 rounded-full cursor-pointer bg-background-red"
                fill="currentColor"
              />
            </button>
            <div class="w-full">
              <div
                :class="[
                  ' font-bold flex-grow text-center flex self-center justify-center text-5xl',
                ]"
                :style="makeStyles(kioskCategoryTitle, titleFont, titleTextTransform)"
              >
                {{ currentItem[`name_${language}`] }}
              </div>
            </div>
          </div>
          <!-- Modal Content Section -->
          <!-- Fix for issue in scrolling to the bottom : Set margin at the bottom of 16 rem when product image is enabled as product image height is of 16 rem -->
<div class="h-full overflow-y-auto" :style="menu.product_images_enabled && selectedMenuCategory.enable_product_images ? 'margin-bottom: 16rem; ': ''">
            <div
              :class="['text-center text-xs md:text-lg px-10']"
              :style="itemDescription"
            >
              {{ currentItem["description" + "_" + language] }}
            </div>
            <div>
              <div v-if="!currentItem.isComboDeal">
                <!-- <div
                  class="px-6 allAdditions"
                  v-for="(modifier, index) in modifiers"
                  :key="modifier.AdditionGroupId"
                >
                  <kiosk-additions
                    :arrayNumber="index"
                    :isComboDeal="currentItem.isComboDeal"
                    :modifier="modifier"
                    :modifiers="modifiers"
                    :allSelectedModifiers="selectedModifiers"
                    :key="index"
                  />
                </div> -->
                <additions-handler
                :modifiers="modifiers"
                :allSelectedModifiers="selectedModifiers"
                :selectedModifiers="selectedModifiers"
                :isComboDeal="currentItem.isComboDeal"
                />
              </div>
              <div v-else>
                <combo-handler
                  @checkSingleComboAddition = checkSingleComboAddition
                  :modifiers="modifiers"
                  :selectedModifiers="selectedModifiers"
                  :isComboDeal="currentItem.isComboDeal"
                  :allSelectedModifiers="selectedModifiers"
                />
              </div>
            </div>
          </div>
          <!-- Bottom Actions Button -->
          <div
            :class="[
              'pt-8 flex justify-center px-6 pb-6 items-center sticky bottom-0 left-0',
              'OrderButton__backdrop',
            ]"
            :style="makeStyles(modifierActionsBackground)"
          >
            <!-- add button -->
            <div
              class="flex flex-row h-8 rounded-xl relative justify-center items-center"
            >
              <button
                @click.stop="deleteNumberOfOrders()"
                class="fill-current focus:outline-none inline-block font-bold rounded-full m-2 w-14 p-2"
                :style="makeStyles(addButtonRadius , modifierAmountButtonBackground)"
              >
                  <IconMinus
                      :stroke="modifierAmountIconColor"
                      :style="btnOutlineIcon"
                  />
              </button>
              <input
                type="number"
                readonly
                class="font-bold text-2xl focus:outline-none text-center h-6 w-10 text-md md:text-basecursor-default flex items-center outline-none justify-center bg-transparent"
                name="morePrders"
                :value="numberOfOrder"
                :style="modifierAmountNumberColor"
              />
              <button
                @click.stop="addNumberOfOrders()"
                class="font-bold rounded-full cursor-pointer focus:outline-none m-2 w-14 p-2"
                :style="makeStyles(addButtonRadius , modifierAmountButtonBackground)"

              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 md:w-10 h-10 xs:w-3 xs:h-3">
                  <path
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    fill="none"
                    :stroke="modifierAmountIconColor"
                    :style="btnOutlineIcon"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
             <!-- && (modifiersSelectionGroups != 0 ? modifierSelectionStep == modifiersSelectionGroups - 1 : true) -->
            <button
              v-if="
                !currentItem.isComboDeal && (modifiersSelectionGroups >1 ? modifierSelectionIndex == modifiersSelectionGroups - 1 : true)||
                (!disableAddToCartButton &&
                  comboItemSelectionStep == modifiers.length - 1)
              "
            @click="
                disableAddToCartButton
                  ? checkModifiers()
                  : addToCartWithModifiers()
              "
              :class="[
                'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 py-4 text-2xl',
                this.disableAddToCartButton && 'bg-primary-light',
                disableAddToCartButton
                  ? 'opacity-40 cursor-not-allowed'
                  : 'opacity-100',
              ]"
              :style="makeStyles(mainButtonRadius,paymentBtnBackground , paymentBtnText)"
            >
              <div class="flex items-center justify-center">

                <p v-if="disableAddToCartButton">
                  {{ lang["add_additions"][language] }} 
                </p>
                <p v-else>{{ lang["add_to_order"][language] }}</p>
                <p
                  class="flex items-center pl-3"
                  v-currency="itemPrice"
                ></p>
              </div>
            </button>
            <button
              v-else
              @click="
                !enableNextStep ||
                comboItemSelectionStep == modifiers.length - 1
                  ? checkModifiers()
                  : nextStep()
              "
              :class="[
                'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 py-4 text-2xl',
                !enableNextStep ||
                comboItemSelectionStep >= modifiers.length - 1
                  ? 'opacity-40 cursor-not-allowed bg-primary-light'
                  : 'opacity-100',
              ]"
              :style="paymentBtnBackground + paymentBtnText"
            >
              <div class="flex items-center justify-center">
                <p
                  v-if="
                    !enableNextStep ||
                    comboItemSelectionStep == modifiers.length - 1
                  "
                >
                  {{ lang["add_additions"][language] }}
                </p>
                <p v-else>{{ lang["next"][language] }}</p>
                <p
                  class="positionPrice pl-3 flex items-center"
                  v-currency="itemPrice"
                ></p>
              </div>
            </button>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import lang from "../lang";
// import KioskAdditions from "../components/KioskAdditions";
import ComboHandler from "../components/ComboHandler.vue";
import AdditionsHandler from "../components/AdditionsHandler.vue";
import IconBackArrow from "./icons/iconBackArrow.vue";
import IconCancel from "./icons/iconCancel.vue";
import IconMinus from "./icons/iconMinus.vue";

export default {
    components:{
    // KioskAdditions,
    ComboHandler,
    IconBackArrow,
    IconCancel,
    IconMinus,
    AdditionsHandler,
},
    props:{
        currentItem:{
            type:Object,
            require:true,
        },
        // numberOfOrder:{
        //     type:Number,
        //     require:true,
        // },
        selectedModifiers:{
            type:Array,
            require:true,
        },
        disableAddToCartButton:{
            type:Boolean,
            require:true,
        },
        enableNextStep:{
            type:Boolean,
            require:true,
        },
        modifiers:{
            type:Array,
            require:true,
        },
        canGoBack:{
            type:Boolean,
            require:true,
        },
        addToCartWithModifiers:{
            type:Function,
            require:true,
        },
        checkModifiers:{
            type:Function,
            require:true,
        },
        itemDescription:{
            type:String,
            require:true,
        }
    },
data() {
    return {
      lang: lang,
      numberOfOrder: 1,
    }
},
computed:{
    ...mapGetters([
        'menu',
        "orderingEnabled",
        "selectedMenuCategory",
        "comboItemSelectionStep",
        "itemPrice",
        "language",
        "modifiersSelectionGroups",
        "modifierSelectionStep",
        "modifierSelectionIndex",
        ]),
  ...mapGetters("Theme", [
        "mainSectionTopRadius",
        "mainButtonRadius",
        "addButtonRadius",
        "listsText",
        "titleFont",
        "titleTextTransform",
        "paymentBtnText",
        "btnOutlineIcon",
        "addMoreItemsNumber",
        "kioskCategoryTitle",
        "btnDestructiveIcon",
        "paymentBtnBackground",
        "btnDestructiveBackground",
        "kioskPlusAndMinusButtons",
        "addMoreItemsIconBackground",
    "modalBackground",
    "backgroundMainFullImage",
        "modifierActionsBackground",
    "menuSubCategoriesBackground",
    "mainSubCategorysBackground",
    "modifierContentBorderRadius",
    "modifierAmountButtonBackground",
    "modifierAmountIconColor",
        "modifierAmountNumberColor"
  ]),
},
methods: {
      nextStep() {
    if (this.modifiersSelectionGroups > 1 && !this.currentItem.isComboDeal) {
      this.$store.commit("modifierSelectionStepIncrement");          
    } 
    else
      this.$store.commit("comboItemSelectionStepIncrement");
    },
    previousStep() {
      if (!this.currentItem.isComboDeal && this.modifiersSelectionGroups > 1) {
        this.$store.commit("modifierSelectionStepDecrement");
      }
      else {
        this.$store.commit("comboItemSelectionStepDecrement");
      }
  },
  addNumberOfOrders() {
      this.$store.commit("Cart/updateOrderItemCount", ++this.numberOfOrder);
  },
    
    deleteNumberOfOrders() {
      if (this.numberOfOrder > 1) {
        this.$store.commit("Cart/updateOrderItemCount", --this.numberOfOrder);
      }
    },


      // delete the arrow of the kiosk navigation when a modal closes
  openingModal() {
    this.numberOfOrder = 1;
      if (document.getElementsByClassName("prev")[0]) {
        document.getElementsByClassName("prev")[0].style.display = "none";
        document.getElementsByClassName("next")[0].style.display = "none";
      }
      this.$emit('open-modifier');
  },
  checkSingleComboAddition() {
     if (this.modifiers[0].Additions.length == 1) {
      let additionId = this.modifiers[0].Additions[0].Id
      document.getElementById(additionId).click()
    }
  }
},
}
</script>

<style scoped>
.FloatingTitle {
  /* background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8463760504201681) 32%, rgba(255,255,255,0.5830707282913166) 66%, rgba(255,255,255,0) 100%); */
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.8463760504201681) 42%,
    rgba(255, 255, 255, 0.5830707282913166) 75%,
    rgba(255, 255, 255, 0) 100%
  );
}
.OrderButton__backdrop {
  /* background: linear-gradient(0deg, white, transparent); */
  background: white;
}
.vm--modal {
  height: 90vh !important;
}

</style>